var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7904 3C5.93253 3 2 6.95301 2 12.3193C2 17.747 5.89157 21.7 11.7084 21.7C13.2241 21.7 14.9855 21.3723 16.2349 20.7374L15.6819 19.0988C14.4325 19.7337 12.9578 20 11.7084 20C6.99759 20 3.88434 16.8458 3.88434 12.3193C3.88434 7.85422 7.03855 4.67952 11.7904 4.67952C16.4602 4.67952 19.6554 7.62892 19.6554 12.012C19.6554 14.4289 19.041 15.7193 17.9349 15.7193C17.3614 15.7193 16.8699 15.3711 16.8699 14.3265V7.36265H14.5964V8.69398C13.7976 7.73133 12.6096 7.23976 11.1759 7.23976C8.3494 7.23976 6.26024 9.39036 6.26024 12.4217C6.26024 15.494 8.3494 17.6446 11.1759 17.6446C12.8145 17.6446 14.0639 17.0301 14.8627 15.8627C15.2108 17.0301 16.153 17.6446 17.4639 17.6446C19.9217 17.6446 21.3964 15.5145 21.3964 11.9711C21.3964 6.74819 17.4434 3 11.7904 3ZM11.606 15.6578C9.8241 15.6578 8.5747 14.4084 8.5747 12.4217C8.5747 10.4554 9.8241 9.22651 11.606 9.22651C13.3265 9.22651 14.6373 10.394 14.6373 12.4217C14.6373 14.4699 13.3265 15.6578 11.606 15.6578Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEt);
export default __webpack_public_path__ + "static/media/et.199ef17a9cf1b11c34bcfb95adcc6f68.svg";
export { ForwardRef as ReactComponent };